import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

function formatViews(views: number): string {
  if (views >= 10000) {
    return (views / 10000).toFixed(1) + '万';
  }
  return views.toString();
}

export default function LatestArticlesSection() {
  const latestArticles = articles.slice(0, 9);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="mb-10 md:mb-14">
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading font-black text-foreground-900 leading-tight">
            实时追踪黑料
          </h2>
          <p className="text-lg md:text-xl font-heading font-semibold text-foreground-700 mt-1 md:mt-2">
            最新吃瓜网址已同步
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {latestArticles.map((article) => (
            <article key={article.id} className="group">
              <Link
                to={`/article/${article.id}`}
                className="block bg-background-50 rounded-lg border border-background-200/70 overflow-hidden transition-all duration-300 cursor-pointer hover:border-background-300/80"
              >
                <div className="relative overflow-hidden" style={{ aspectRatio: '4/3' }}>
                  <img
                    src={article.image}
                    alt={article.title}
                    title={article.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                    loading="lazy"
                  />
                  {article.tag && (
                    <span className={`absolute top-3 left-3 inline-block px-2.5 py-0.5 text-xs font-label font-semibold text-background-50 ${article.tagColor} rounded-full`}>
                      {article.tag}
                    </span>
                  )}
                </div>

                <div className="p-4 md:p-5">
                  <div className="flex items-center gap-3 mb-2.5">
                    <span className="text-xs font-label text-primary-500 font-medium">
                      {article.categoryName}
                    </span>
                    <span className="text-xs text-foreground-400">
                      {article.date}
                    </span>
                  </div>

                  <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 leading-snug mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors duration-200">
                    {article.title}
                  </h3>

                  <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                    {article.excerpt}
                  </p>

                  <div className="flex items-center gap-4 text-xs text-foreground-400">
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {formatViews(article.views)}阅读
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-chat-3-line"></i>
                      {formatViews(article.comments)}评论
                    </span>
                  </div>
                </div>
              </Link>
            </article>
          ))}
        </div>

        <div className="flex justify-center mt-10 md:mt-12">
          <Link
            to="/category/latest"
            className="inline-flex items-center gap-2 px-8 py-3 bg-foreground-900 hover:bg-foreground-800 text-background-50 text-sm font-label font-medium rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            查看全部爆料
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}